import Axios from "axios";

// API gateway timeout is 30 seconds.
// This should be handled via a queue but for now.
// This fix is going in the backlog.
const TWENTY_FIVE_SECONDS = 25000;

const deployApiClient = Axios.create({
  baseURL: process.env.REACT_APP_DEPLOY_API_URL,
  headers: {
    "x-api-key": process.env.REACT_APP_DEPLOY_API_KEY,
  },
});

const buildApp = (subdomain, platform, releaseMessage) =>
  deployApiClient
    .post("run-build", { subdomain, platform, release_message: releaseMessage })
    .then((result) => result.data);

const createAppScreenshots = (subdomain, platform) =>
  deployApiClient
    .post(
      "create-screenshots",
      { subdomain, platform },
      { timeout: TWENTY_FIVE_SECONDS }
    )
    .then((result) => result.data);

const getAppStatus = (subdomain) =>
  deployApiClient.get(`app/${subdomain}`).then((result) => result.data);

const releaseApp = (distributionAppId) =>
  deployApiClient
    .post(`release`, { distributionAppId })
    .then((result) => result.data);

const AppDeployApi = {
  buildApp,
  createAppScreenshots,
  getAppStatus,
  releaseApp,
};

export default AppDeployApi;
